import { createContext, useContext, useMemo, useState } from 'react';
import { useAuth } from './AuthContext';

const OverviewCurrencyContext = createContext({
	currency: 'USD',
	setCurrency: () => {},
	availableCurrencies: ['USD', 'EUR', 'AMD', 'RUB'],
	setAvailableCurrencies: () => {},
});

export const useOverviewCurrency = () => useContext(OverviewCurrencyContext);

export const OverviewCurrencyProvider = ({ children }) => {
	const { userInfo } = useAuth();
	const [currency, setCurrency] = useState(
		() => userInfo?.currency_preference || 'USD',
	);
	const [availableCurrencies, setAvailableCurrencies] = useState([
		'USD',
		'EUR',
		'AMD',
		'RUB',
	]);

	const value = useMemo(
		() => ({
			currency,
			setCurrency,
			availableCurrencies,
			setAvailableCurrencies,
		}),
		[currency, setCurrency, availableCurrencies, setAvailableCurrencies],
	);

	return (
		<OverviewCurrencyContext.Provider value={value}>
			{children}
		</OverviewCurrencyContext.Provider>
	);
};
